import React from 'react';

import { MainContext } from './MainContext.js';

export interface MainProviderProps {
  main?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * Main provider component allows to set the main component for the application.
 */
export const MainProvider: React.FC<MainProviderProps> = ({ children, main }) => {
  return <MainContext.Provider value={main ?? null}>{children}</MainContext.Provider>;
};
